import { useEffect, useState } from "react";
import styles from "../../styles/SuccessStories/Testimonial.module.css"; // Importing the module CSS

const testimonials = [
  {
    id: 1,
    clientName: "Harsh Japra",
    role: "Head of Media Relations at Mobupps",
    company: "Mobupps",
    industry: "IT Consulting",
    challenge:
      "Harsh Japra needed a seamless, user-friendly financial calculator website that worked flawlessly across devices while maintaining a strong brand identity.",
    approach:
      "LovenCoders handled everything from MVP development to branding and UX/UI design, delivering a fully responsive, visually appealing, and high-performance website that exceeded expectations.",
    feedback:
      "I worked with LovenCoders to develop 5nanceCalculators.com, and I couldn’t be happier! Their team was professional, attentive, and made the process seamless. The site looks fantastic, is user-friendly, and works flawlessly across devices. They exceeded my expectations with creative touches. From MVP development to branding and launch, they handled everything smoothly. Highly recommend their top-notch web development services!",
    image: "/HarshJapra.jpg",
  },
  {
    id: 2,
    clientName: "Sriram Vijayakumar",
    role: "Co-Founder at Redvis Media Labs",
    company: "Redvis Media Labs",
    industry: "Training",
    challenge:
      "Navigating complex startup challenges by making smart technical and strategic decisions.",
    approach:
      "From conceptualization to execution, LovenCoders handled MVP development, branding, and UX/UI design, ensuring a seamless, visually appealing, and high-performance website tailored to client needs.",
    feedback:
      "Working with Mohit sir has been a great experience. His deep expertise in technology, startups, and innovation helped us make smart decisions and overcome challenges. Mohit sir and his team at Lovencoders delivered high-quality solutions, ensuring everything was efficient and effective. His mentorship in leadership, productivity, and strategy was incredibly helpful. He is truly passionate about helping startups grow. We appreciate his support and look forward to working with him again!",
    image: "/SriramVijayakumar.jpg",
  },
  {
    id: 3,
    clientName: "Avinash Lele",
    role: "Business Leader",
    company: "IT Consulting",
    industry: "IT Consulting",
    challenge:
      "The challenge was to maintain a high standard of excellence while optimizing technical processes and execution for impactful results.",
    approach:
      "LovenCoders delivered a complete solution, covering MVP development, branding, and UX/UI design, resulting in a fully responsive, high-performance website that exceeded all expectations.",
    feedback:
      "Very thorough and competent in understanding the key technical aspects of the solution that is being built. Knowledgeable in different technological areas which makes him very effective as a Program Manager. His focus on excellence is key to experiencing a world class work product.",
    image: "/AvinashLele.jpg",
  },
  // Add more testimonials here
];

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval);
  }, [currentIndex]);

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const {
    clientName,
    role,
    company,
    industry,
    challenge,
    approach,
    feedback,
    image,
  } = testimonials[currentIndex];

  return (
    <div className={styles.testimonialContainer}>
      <div className={styles.testimonialInnerContainer}>
        <h2 className={styles.heading}>Featured Success Stories</h2>
        <p className={styles.subheading} style={{opacity:"0"}}>Lorem Ipsum</p>
        <div className={styles.testimonialCard}>
          {/* Client Image */}
          <div className={styles.clientSection}>
            <img src={image} alt={clientName} className={styles.clientImage} />
            <p className={`${styles.clientName} ${currentIndex === 2 ? styles.clientNameAdjusted : ""}`}>
              <span className={styles.clientNameTitle}>Client:</span><span>{clientName}</span>
            </p>
            <p className={styles.clientRole}>
              <span className={styles.clientNameTitle}>Role:</span><span>{role}</span>
            </p>
          </div>
          {/* Testimonial Details */}
          <div className={styles.detailsSection}>
            <div>
              <h3 className={styles.companyName}>{company}</h3>
            </div>
            <div className={styles.clientNameAndTitleCon}>
              <p
                className={`${styles.clientNameTitle} $`}
              >
                <span className={styles.fw600}>Role</span> : {role}
              </p>
              <p
                className={`${styles.clientNameTitle} ${styles.fw600}`}
              >
                <span className={styles.fw600}>Industry</span>: {industry}
              </p>
            </div>
            <hr style={{ border: "1px solid rgba(217, 217, 217, 1)" }} />
            <h4 className={`${styles.subheading} ${styles.fw700}`}>
              The Challenge
            </h4>
            <p className={styles.subheadingDesc}>{challenge}</p>
            <h4 className={`${styles.subheading} ${styles.fw700}`}>
              Our Approach
            </h4>
            <p className={styles.subheadingDesc}>{approach}</p>
            <p className={styles.feedback}>{feedback}</p>
          </div>
        </div>
        {/* Navigation Controls */}
        <div className={styles.navigation}>
          <button onClick={prevTestimonial} className={styles.navButton}>
            <img
              src="/testimonialleft.svg"
              alt="left-icon"
              height={40}
              width={40}
            />
          </button>
          {/* Indicator Dashes */}
          <div className={styles.indicatorContainer}>
            {testimonials.map((_, index) => (
              <span
                key={index}
                className={`${styles.indicator} ${
                  index === currentIndex ? styles.activeIndicator : ""
                }`}
              ></span>
            ))}
          </div>
          <button onClick={nextTestimonial} className={`${styles.navButton}`}>
            <img
              src="/testimonialleft.svg"
              alt="right-icon"
              height={40}
              width={40}
              className={` ${styles.rotateRight}`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
export default Testimonial;
